import { MenuItem } from '@material-ui/core'
import { SearchOutlined } from '@material-ui/icons'
import { useState } from 'react'

import Button from '@/components/button'
import InputText from '@/components/input-text'

import { DateSearchField } from './date-search-field'
import { StatusSearchField } from './status-search-field'
import { useStyles } from './styles'
import { TagSearchField } from './tag-search-field'
import { TextSearchField } from './text-search-field'

export type SearchType = 'created_at' | 'demand_name' | 'project' | 'status'

export interface SearchTypesComponentsProps {
  value: string
  onChange: (value: string) => void
}

export interface OnSubmitSearchParams {
  search: string
  searchType: SearchType
}

const searchTypesComponents = {
  created_at: DateSearchField,
  demand_name: TextSearchField,
  project: TextSearchField,
  tag: TagSearchField,
  status: StatusSearchField,
}

interface SearchProps {
  onSubmitSearch: (params: OnSubmitSearchParams) => void
  initialSearch: string
  initialSearchType: SearchType
}

export function Search({
  onSubmitSearch,
  initialSearch,
  initialSearchType,
}: SearchProps) {
  const classes = useStyles()

  const [search, setSearch] = useState(initialSearch)
  const [searchType, setSearchType] = useState<SearchType>(initialSearchType)

  const CurrentInputTypeComponent = searchTypesComponents[searchType]

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    onSubmitSearch({
      search,
      searchType,
    })
  }

  return (
    <form className={classes.container} onSubmit={handleSubmit}>
      <InputText
        select
        SelectProps={{
          MenuProps: {
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            classes: { paper: classes.menuList },
            elevation: 0,
          },
        }}
        value={searchType}
        onChange={(e) => {
          setSearchType(e.target.value as SearchType)
          setSearch('')
        }}
      >
        <MenuItem className={classes.menuItem} value='created_at'>
          Data de Cadastro
        </MenuItem>
        <MenuItem className={classes.menuItem} value='demand_name'>
          Nome do Diagnóstico
        </MenuItem>
        <MenuItem className={classes.menuItem} value='project'>
          Projeto
        </MenuItem>
        <MenuItem className={classes.menuItem} value='tag'>
          Tags
        </MenuItem>
        <MenuItem className={classes.menuItem} value='status'>
          Status
        </MenuItem>
      </InputText>

      <CurrentInputTypeComponent value={search} onChange={setSearch} />

      <Button labelOnly aria-label='Buscar' type='submit'>
        <SearchOutlined />
      </Button>
    </form>
  )
}
